import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';

/** Job service (polling/sessionStorage/download) da Ficha Cadastral do órgão/delegacia. */
@Injectable({ providedIn: 'root' })
export class FichaCadastralOrgaoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'ficha-cadastral-orgao-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.orgao.reports.fichaCadastral;
}
